// settings
const url = window.location.origin;
let apiUrl;
let siteLogoChanged = false;
if (url === 'https://sew.myproof.net') {
  siteLogoChanged = true;
}
if (url === 'https://myproof.net') {
  apiUrl = 'https://myproof.net/api';
} else if (url.includes('localhost')) {
  // http://192.168.1.32:8081/api
  // 'http://192.168.2.46:5133/api'
  // apiUrl = 'http://192.168.1.32:8081/api';
  apiUrl = 'http://localhost:60124/api';
  // apiUrl = 'http://87.106.209.51:8082/api';
} else if (url === 'https://sew.myproof.net') {
  apiUrl = 'https://sew.myproof.net/api';
} else if (url === 'https://zf.myproof.net') {
  apiUrl = 'https://zf.myproof.net/api';
} else {
  apiUrl = 'http://87.106.209.51:8082/api';
}
export const SITE_LOGO_CHANGED = siteLogoChanged;
export const BACK_URL = apiUrl;

// roles
export const ROLE_PROOF_READER = 'proofreader';
export const ROLE_QA_EXPERT = 'qaexpert';
export const ROLE_SYSTEM_ADMIN = 'administrator';
export const ROLE_PROJECT_MNG = 'projectmanager';
export const ROLE_LSP = 'lsp';
export const ROLE_NOT_DEFINED = 'notdefined';
export const ROLE_TRIAL = 'trial';
export const ROLE_QA_MANAGER = 'qamanager';
export const ROLE_CUSTOMER = 'customer';

// statuses for tasks
export const TASK_STATUS = [
  {
    ID: 3,
    Name: 'Open',
  }, {
    ID: 4,
    Name: 'Started',
  }, {
    ID: 6,
    Name: 'Ready',
  },
];

// statuses for jobs
export const JOB_STATUS = [
  {
    ID: 1,
    Name: 'Preparation',
  }, {
    ID: 2,
    Name: 'Evaluation',
  }, {
    ID: 3,
    Name: 'Validation',
  },
];
export const JOB_STATUS_PREPARATION = 'Preparation';
export const JOB_STATUS_EVALUATION = 'Evaluation';
export const JOB_STATUS_VALIDATION = 'Validation';
export const JOB_STEP_OPEN = 'Open';
export const JOB_STEP_ACCEPTED = 'Accepted';
export const JOB_STEP_READY = 'Ready';

export const DEFAULT_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAU/SURBVHhe7ZxXiCxFFEBXxYCgIibMEcwJwYAo/ogioqhfgn488cP3UFDMijkL+mf6NGDOqCiCohhRDBhQVDDnBObsOfAaluXW7M7bnt4O98CBZWe2+96a2erqW1U9lSRJkiRJkiRJkiRJkiQtY2XcDy/E+/Bt/B7/xD+W/vwW+tr56HtXwmSe7Io34I/435h+h/7tLpiMyU74CP6LUeOOo8d4CHfEZBZWwavxL4wacz56zCvR7iwJ2Apfxajx6vRl3BKTaeyGX2PUYJPwS/ScCeyOc7nI/o1P4km4B66LKy7Vn/2dr/ke3xsdY7qec/Afgt3ObN/8n/FiXAvniu/1b37B6JiVnnsLHCRecF/BqGEqb8X1cVnxb2/D6NiVXhMGec9wFUYNonYhp2BdeKxR3ZKjo0GxM5aGmjbU4Vg3R2DpQ/COenscDA9j1BB6Mk6KUzE6pz6Ig8DyQukO9xacNHdgdG5j8j+z91yPUQM4YpnPBXeubIil0dE12GssA/yAUfIXYVNcilEMFvC8r+gtlomjxL04jjPOny9rY+mCvA/2lgswSvoJbJqnMIrlPOwtD2CU9InYNI62oljuxd7irFWU9J7YNHthFMub2Fu8yEVJ2yc3zToYxfIN9hbnb6OkF6IW44gsiuV37C2/YZR0mz4AY+wtX2CUtN1B05S6oM+xt7icJEraC2LT7I1RLG9gb7kbo6SdyWqa0jD0TuwtZ2GUtNOITfM0RrGcib1lX4ySblMpwhh7ywr4FUaJX4JNcRlGMThIWB57zbUYJd9UOXoj/BWjGHpfjpbt8B+MGsAJ9ElzF0bnNqZtcBDcj1EjqNOGk+I0jM6pxjQYtkVv+aOG8OLoBHrdjJqUNxZjGhQunIoaQ20ov611cTqWGl/ddzA4rMW8iFGDVN6OG+Cy4vxvaRK+8nkc7GYORyQulI0aptIRi0PUcepFvtd539Jop9JhpzEMGpepfItRA03XLsRpREsITuCsh35z1Z+tJ/ma7xnV3VRa9/fcCbgeZ7b/hDr1XINYAzQOG+MLGDVYndrnD77bibBMcTS6TjNquDr02Edh78sN47AcHonvYdRok/BdPAwHj7f+z2DUSE1oGXxrHBx+6x2xlOaIm9ShquuSjGkQrI7uaI8ao+RHeCMuwf3RXY5rYrVHzJ/9na8djzfhJxgdq+Q9uBr2Gu9MX8eoAWb6KV6O89k44YbvK9CJ9ugcM30NmyiJLwibo9/kKPHpvoOLsM7ygMc6Budyof8QN8Fe4bj7A4wSrvwJLUVPcnm4H4SFOc8VxVDpB9Wbe4VVcbZuxxsw/0Oawq2pL2EUS6U7OI2983hxixKsdIpyITZFWI29DqOYKl1G02kWY5RY5bm40JT2LFQeh53EYeGocvDZ2BZGfQguFujkbvrHMEpI7XbaRmnzoPrsok5xCEaJqLNgdQ4x68KYRl2YD8JOYKXRG5ooCYd/m2Fbsdv04SBR7I6KOlGuOBSjBHSSS07q4gyMYtcDsPU8jlHwloC7sAfXruh9jHJ4FFuNN1OlxxBYXugKx2KUg7ltiq2l9O9rYa2NF94SxlrazdPqbrQ0p2tVs2v4DKEol2exlViTLy0H2QG7hg98jXIxxzWwdRyMUcCWoLvKZxjldCC2jnMwCtaZrK5yM0Y5udWqdZTWYDqN2FVOwCgn16y2jtIF2HnarmJXE+X0HLaOUn/Z5ccE+1zTKKePsXWUnn7r6KiruHMzyslcW0dpCNqlG7CZGHuUk4/cTJIkSZIkSZIkSZIkSZIkSZIkSZJkFqam/gdhE0AONoYdcwAAAABJRU5ErkJggg==';

export const DESCRIPTION = {
  common: '',
  proofreader: '',
  qa: '',
};

export const CHANGE_HISTORY_ICON = [
  {
    ID: 1,
    Name: 'history-created',
  }, {
    ID: 2,
    Name: 'history-sent',
  },
];

export const REGEX = {
  passwordRegex: /^[a-zA-Z0-9!@#$%^&*+-]{6,21} ?$/,
  emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  userNameRegex: /^(?!.*__.*)(?!.*\.\..*)[a-zA-Z0-9_.]+$/,
  urlRegex: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
};

export function parseToken () {
  const userToken = localStorage.getItem('user-token') || '';
  return JSON.parse(window.atob(userToken.split('.')[1].replace('-', '+').replace('_', '/')));
}
